var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefreshIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D7E1E8",
    fillRule: "nonzero",
    d: "M12 0C6.89 0 2.617 3.16.875 7.625l1.844.75C4.176 4.64 7.71 2 12 2c3.24 0 6.134 1.59 7.938 4H16v2h7V1h-2v3.094A11.93 11.93 0 0 0 12 0m9.28 15.625C19.824 19.36 16.29 22 12 22c-3.276 0-6.157-1.612-7.97-4H8v-2H1v7h2v-3.094C5.19 22.386 8.395 24 12 24c5.11 0 9.383-3.16 11.125-7.625z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh-icon.50dc7a15.svg";